import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getActionMenuDividerLineSx } from '../../utils/actionMenuStyles';

/**
 * Standalone rule between action-menu rows. Not a MenuItem — flex gap on the
 * parent list supplies equal spacing above and below the line.
 */
const ActionMenuDividerLine = () => {
  const theme = useTheme();
  return <Box component="li" aria-hidden sx={getActionMenuDividerLineSx(theme)} />;
};

export default ActionMenuDividerLine;
